const state = {
  divisionFront: {},
  currentSeason: null,
  divisions: [],
  division: {}
}

const getters = {
  division(state) {
    return state.division
  },
  divisions(state) {
    return state.divisions
  },
  divisionFront(state) {
    return state.divisionFront
  },
  currentSeason(state) {
    return state.currentSeason
  }
}

const mutations = {
  SET_DIVISIONS_ADD(state, payload) {
    state.divisions.unshift(payload)
  },
  SET_DIVISION(state, payload) {
    state.division = payload
  },
  SET_DIVISIONS(state, payload) {
    state.divisions = payload
  },
  SET_DIVISION_IMAGE(state, payload) {
    state.divisions = state.divisions.map(div => {
      if (div.id === payload.id) {
        div.image = payload.image
      }
      return div
    })
  },
  SET_DIVISION_DELETE(state, payload) {
    state.divisions = state.divisions.filter(div => {
      return div.id !== payload
    })
  },
  SET_DIVISION_EDIT(state, payload) {
    state.divisions = state.divisions.map(div => {
      if (div.id === payload.id) {
        div.name = payload.name
        div.teams_down = payload.teams_down
        div.teams_playoffs = payload.teams_playoffs
        div.competition_type = payload.competition_type
        div.is_premium = payload.is_premium
        div.state = payload.state
      }
      return div
    })
  },
  SET_DIVISION_FRONT(state, payload) {
    state.divisionFront = payload
  },
  SET_CURRENT_SEASON(state, payload) {
    state.currentSeason = payload
  }
}

const actions = {
  SET_DIVISION_DELETE(context, payload) {
    context.commit('SET_DIVISION_DELETE', payload)
  },
  SET_DIVISION_EDIT(context, payload) {
    context.commit('SET_DIVISION_EDIT', payload)
  },
  SET_DIVISIONS_ADD(context, payload) {
    context.commit('SET_DIVISIONS_ADD', payload)
  },
  SET_DIVISION_IMAGE(context, payload) {
    context.commit('SET_DIVISION_IMAGE', payload)
  },
  SET_DIVISION(context, payload) {
    context.commit('SET_DIVISION', payload)
  },
  SET_DIVISIONS(context, payload) {
    context.commit('SET_DIVISIONS', payload)
  },
  SET_DIVISION_FRONT(context, payload) {
    context.commit('SET_DIVISION_FRONT', payload)
  },
  SET_CURRENT_SEASON(context, payload) {
    context.commit('SET_CURRENT_SEASON', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
